import { render } from "./IndexButton.vue?vue&type=template&id=60fc9904&ts=true"
import script from "./IndexButton.vue?vue&type=script&lang=ts"
export * from "./IndexButton.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__